import httpManager from "@/app/shared/utils/httpManager";

export async function disconnectAgentById(userId, { unassign = false } = {}) {
  const body = { unassign_tickets: unassign };

  const url = `/users/${userId}/disconnect/`;
  await httpManager.put(url, body);
}
